<pr-form
  (onSubmit)="submit()"
  title="Paramétrez votre simulation"
  [formGroup]="form"
>
  <h3>Paramètres de l'investissement</h3>

  <pr-input label="Valeur du bien" suffix="€" [derrors]="derrors">
    <input formControlName="investedAmount" type="text" />
  </pr-input>
</pr-form>
